import styled from 'styled-components';
import sizeStandards from '../../size-standards';

const AvatarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .jersey-icon {
    width: 90px;
    height: 100px;
  }

  .last-name {
    position: absolute;
    top: 18px; /* adjust to position on the jersey */
    font-weight: lighter;
    font-size: 11px;
    text-transform: uppercase;
  }

  .shirt-number {
    position: absolute;
    bottom: 26px; /* adjust to be below last name on the jersey */
    font-weight: normal;
    font-size: 18px;
  }

  @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
    .jersey-icon {
      width: 72px;
      height: 82px;
    }

    .last-name {
      top: 15px;
      font-size: 9px;
    }
    .shirt-number {
      bottom: 20px;
      font-size: 15px;
    }
  }
`;

export default AvatarWrapper;
